module.exports = __webpack_public_path__ + "static/ss4-cbbcce6abb8efa36c6971d3e79df1504.png";